<template>
  <!--为你推荐-->
  <div>
    <div class="recommend stairs">
      <!--头部-->
      <div class="weekly-title">
        <div class="hot-content">
          <div class="weekly-title-logo">热门推荐</div>
          <div class="weekly-time">
            <!--  <div class="weekly-more">
                            <router-link to="/">
                                查看更多
                                <Icon type="ios-arrow-forward" />
                            </router-link>
                        </div>-->
          </div>
        </div>
      </div>
      <!--头部-->
      <!--内容-->

      <div class="week-items-bottom" @click="saveLine('热门推荐')">
        <div class="weekly-other-item" v-if="goodsList.length > 0">
          <div class="weekly-goods" v-for="(item, index) in goodsList" :key="index" @click="goIndexDetail(item)">
            <a>
              <p class="weekly-goods-icon-1" v-if="item.favorites_type === 0">
                <span>
                  <img src="static\img\index\img\icon_6(1).png" alt=""
                    @click.stop="handleCollect(item, 1, index, '热门推荐')" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1">
                <span>
                  <img src="static\img\index\img\icon_7.png" alt="" @click.stop="handleCollect(item, 2, index, '热门推荐')" />
                </span>
              </p>
              <!--收藏后变颜色-->
              <div class="weekly-goods-img">
                <img class="move-img" :src="item.img_url ||
                  '../../../static/img/goodsList/goods_default_img.jpg'
                  " :onerror="defaultGoodsImg" alt="图片破损" />
                <div class="frame-img" v-if="item.frame !== ''"><img :src="item.frame" alt=""></div>
              </div>
              <p class="weekly-goods-loginPrice">
                <!--到手价-->
                <span class="weekly-price" v-if="item.arrive_hand_price !== ''">￥{{ item.arrive_hand_price
                }}/{{ item.unit }}</span>
                <!--到手价-->
                <span class="weekly-price" v-if="item.arrive_hand_price === ''">￥{{ item.selling_price
                }}/{{ item.unit }}</span>
                <span class="weekly-old-price" v-if="item.selling_price !== item.original_price"><s>￥{{
                  item.original_price }}</s></span>
              </p>
              <p class="weekly-goods-intro">{{ item.goods_name }}</p>
              <!-- <p class="weekly-goods-spec">{{ item.manufacturer_name }}</p>
              <p class="weekly-goods-spec">效期：<span style="color: red;">{{ item.expiration_date }}</span></p>-->
              <p class="weekly-goods-spec">规格：{{ item.specification }}</p>
              <!-- <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
              <div class="goods-bottom-icon">
                <p v-for="(label, index) in getLabels(item.lables)" :class="{
                  'pro-more-1': index === 0,
                  'pro-more-2': index === 1,
                  'pro-more-3': index === 2,
                  'pro-more-4': index === 3
                }" :key="index">
                  {{ goodsLabelSet[label] }}
                </p>
              </div>

            </a>
          </div>
        </div>
      </div>
      <div class="loadingPage" v-if="loadingPage">
        <Spin>
          <div><img style="margin-top: 80px;;width: 100px;height: 100px;" src="static/img/goodsList/load.gif" alt="">
          </div>
          <!--<Icon style="margin-top: 200px" type="ios-loading" size=40 class="demo-spin-icon-load"></Icon>-->
          <div style="margin-top: 10px;marginBottom:80px">加载中...</div>
        </Spin>
      </div>
      <div id="navRe"></div>

      <div class="empty" v-if="goodsList.length <= 0 && !loadingPage">
        <img src="static\img\personal\nothing.png" />
        <p>暂时没有商品看看其他的吧~</p>
      </div>
      <!--内容-->
    </div>
    <Collect :CollectModel.sync="CollectPopup"></Collect>
    <NoCollect :NoCollectModel.sync="NoCollectPopup"></NoCollect>
  </div>
  <!--为你推荐-->
</template>

<script>
import store from "@/vuex/store";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { getRecommend } from "@/api/commonApi";
import { defaultGoodsLabelSet } from "@/components/nav/staticData";
import { collection } from "@/api/goods";
import Collect from "@/components/popup/Collect";
import NoCollect from "@/components/popup/NoCollect";
import { behaviorcollect, lineLocal } from '@/api/apiPot.js'
export default {
  name: "Recommend",
  components: {
    Collect,
    NoCollect
  },
  data() {
    return {
      goodsList: [],
      defaultGoodsImg:
        'this.src="' +
        require("../../../static/img/goodsList/goods_default_img.jpg") +
        '"',
      goodsLabelSet: defaultGoodsLabelSet,
      CollectPopup: false, //收藏弹出框
      NoCollectPopup: false, //取消收藏弹出框
      currentPage: 1, // 当前页数
      pageSize: 10, // 每页数据条数
      loadingPage: false, // 加载状态
      deB: null
    };
  },
  computed: {
    ...mapState(["userInfo"])
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.recommendList();
  },
  methods: {
    saveLine(e) {
      lineLocal({ source_type: 2, source_info: e })
    },
    handleScroll() {
      const scrollY = window.scrollY;
      const sectionElement = document.querySelector('#navRe');
      const sectionTop = sectionElement.getBoundingClientRect().top + scrollY;
      clearTimeout(this.deB)
      this.deB = setTimeout(() => {
        if ((scrollY >= (sectionTop - 900)) && !this.loadingPage) {
          this.recommendList(this.currentPage + 1)
        }
      }, 300)
    },
    recommendList(page) {
      /**为你推荐 */

      if (page) {
        this.currentPage = page
      }
      this.loadingPage = true;
      getRecommend({
        page: this.currentPage,
      })
        .then(res => {

          this.goodsList.push(...res.data);
          if (res.last_page <= this.currentPage) {
            window.removeEventListener("scroll", this.handleScroll);
          }
        })
        .catch(err => {
        }).finally(() => {
          this.loadingPage = false;
        });
    },
    goIndexDetail(item) {
      // this.$router.push({
      //   path: item.ad_url
      //   /* query: { id: item.goods_id }*/
      // });
      // 跳转新页面
      window.open(this.$router.resolve({ path: item.ad_url }).href, "_blank");
    },
    getLabels(labels) {
      if (labels) {
        return labels.split(",").length > 4
          ? labels.split(",").slice(3)
          : labels.split(",");
      } else {
        return ['0'];
      }
    },
    // 收藏	1添加2取消
    handleCollect(item, type, index, e) {
      if (type == 1) {
        this.saveLine(e)
        behaviorcollect({ goods_id: item.goods_id })
      }
      collection({
        goods_id: item.goods_id,
        type: type
      })
        .then(res => {
          if (res.code + "" !== "200") return;
          this.$store.dispatch("goods/setRightRefresh", Math.random() * 10);

          if (type == 1) {
            this.CollectPopup = true;
            item.favorites_type = 1;
            this.$set(this.goodsList, index, item);
          } else {
            this.NoCollectPopup = true;
            this.collectState = true;
            item.favorites_type = 0;
            this.$set(this.goodsList, index, item);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  store
};
</script>

<style lang="less" scoped>
.recommend {
  padding-bottom: 30px;
  width: 1200px;
  margin: 0 auto;

  /*单促销标签*/
  .pro-one {

    // display: none;
    .promotion-gm {
      width: 50px;
      height: 50px;
      background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
      box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-xp {}

    .promotion-zs {
      width: 62px;
      height: 62px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-hg {
      width: 62px;
      height: 62px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-ms {
      width: 62px;
      height: 62px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-xq {
      width: 66px;
      height: 64px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
      // display: none;
    }

    .promotion-tj {
      width: 64px;
      height: 63px;
      position: absolute;
      top: -4px;
      left: 10px;
      z-index: 10;
    }

    .promotion-txt {
      width: 140px;
      position: absolute;
      top: 8px;
      left: 70px;
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  /*多促销标签*/
  .pro-more {
    width: 100%;
    position: absolute;
    z-index: 4;

    .pro-other {
      display: inline-block;
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      box-sizing: border-box;
      padding: 5px 8px;
      width: 156px;
      background: #fff;
      box-shadow: 0px 2px 4px 0px rgba(216, 216, 216, 0.3);
      border-radius: 6px;
      position: relative;
      text-align: left;
      line-height: 14px;
    }

    .pro-other-1 {
      display: none;
    }

    .pro-other-1::after {
      content: "";
      position: absolute;
      left: 22px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
      box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    }

    .pro-other-2 {
      display: none;
    }

    .pro-other-2::after {
      content: "";
      position: absolute;
      left: 39px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
      box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    }

    .pro-other-3 {
      margin-left: -37%;
      display: none;
    }

    .pro-other-3::after {
      content: "";
      position: absolute;
      left: 62px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
      box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    }

    .pro-other-4 {
      margin-left: -98%;
      display: none;
    }

    .pro-other-4::after {
      content: "";
      position: absolute;
      left: 120px;
      top: -5%;
      width: 0;
      height: 0px;
      border-style: solid;
      border-width: 7px;
      border-color: #fff #fff transparent transparent;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
      box-shadow: 3px -3px 3px rgb(216 216 216 / 30%);
    }

    .pro-more-1 {
      width: 57px;
      height: 26px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      background: url("/static/img/goodsList/pro_more_1.png") no-repeat;
      font-size: 12px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      line-height: 26px;
    }

    .pro-more-1:hover .pro-other-1 {
      display: block;
    }

    .pro-more-2 {
      width: 82px;
      height: 26px;
      position: absolute;
      top: 0;
      left: 38px;
      z-index: 9;
      background: url("/static/img/goodsList/pro_more_2.png") no-repeat;
      font-size: 12px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      text-indent: 10px;
      line-height: 26px;
    }

    .pro-more-2:hover .pro-other-2 {
      display: block;
    }

    .pro-more-3 {
      width: 77px;
      height: 26px;
      position: absolute;
      top: 0;
      left: 99px;
      z-index: 8;
      background: url("/static/img/goodsList/pro_more_3.png") no-repeat;
      font-size: 12px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      text-indent: 7px;
      line-height: 26px;
    }

    .pro-more-3:hover .pro-other-3 {
      display: block;
    }

    .pro-more-4 {
      width: 81px;
      height: 26px;
      position: absolute;
      top: 0;
      left: 148px;
      z-index: 7;
      background: url("/static/img/goodsList/pro_more_4.png") no-repeat;
      font-size: 12px;
      font-family: PingFangHK-Semibold, PingFangHK;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      text-indent: 19px;
      line-height: 26px;
    }

    .pro-more-4:hover .pro-other-4 {
      display: block;
    }
  }

  .weekly-title {
    padding-bottom: 25px;
  }

  .hot-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 15px;
  }

  .weekly-title {
    .weekly-title-logo {
      font-size: 36px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 600;
      color: #333333;
      line-height: 56px;
      width: 188px;
    }

    .weekly-time {
      width: 100%;
      border-bottom: 2px solid #ccc;
      margin-left: 15px;
      /* color: #333333;*/
      height: 45px;

      .weekly-deadline {
        font-size: 24px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 33px;
        padding-bottom: 9px;
      }

      .weekly-more {
        text-align: right;
      }

      .weekly-more a {
        font-size: 14px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #666;
        line-height: 33px;
      }

      .weekly-more a:hover {
        color: #DC0026;
      }
    }
  }

  .weekly-classify {
    .weekly-classify-ul {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: flex-end;
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      padding: 28px 0;
    }

    .weekly-classify-ul li {
      padding-left: 20px;
      cursor: pointer;
    }

    .weekly-classify-ul li:hover {
      color: #DC0026;
    }

    .weekly-classify-ul li.active {
      color: #DC0026;
    }
  }

  .week-items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    /*  -webkit-box-pack: justify;
              -ms-flex-pack: justify;
              justify-content: space-between;*/
    .week-items-carousel {
      width: 715px;
      height: 280px;
      box-shadow: 0px 4px 12px 0px rgba(179, 179, 179, 0.2);
      margin-right: 12px;
    }

    .week-items-carousel {}

    .week-items-carousel /deep/ .ivu-carousel-dots-inside {
      bottom: 20px;
    }

    .week-items-carousel /deep/ .ivu-carousel-dots li button {
      background: #DC0026;
    }
  }

  .week-items-bottom {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    .weekly-goods:last-child {
      margin-right: 0;
    }
  }

  .weekly-other-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    /* display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    flex-flow: row wrap;
    align-content: flex-start;*/
    /*text-align: center;*/
    .weekly-goods {
      width: 230px;
      // height: 330px;
      padding-bottom: 15px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #f0f0f0;
      box-shadow: 0px 4px 8px 0px rgba(179, 179, 179, 0.2);
      position: relative;
      margin-right: 12px;
      margin-bottom: 15px;
    }

    .weekly-goods:nth-child(5n) {
      margin-right: 0;
    }

    .weekly-goods-icon {
      width: 50px;
      height: 50px;
      background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
      box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #ffffff;
      line-height: 50px;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 10px;
      z-index: 10;
    }

    .weekly-goods-icon-1 {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      cursor: pointer;
      display: none;
      z-index: 10;

      span {
        line-height: 33px;
      }
    }

    .weekly-goods:hover .weekly-goods-icon-1 {
      display: block;
    }

    .weekly-goods-icon-2 {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 30px;
      height: 30px;
      cursor: pointer;
      display: none;
      z-index: 10;

      span {
        line-height: 33px;
      }
    }

    .weekly-goods:hover .weekly-goods-icon-2 {
      display: block;
    }

    /*.weekly-goods:hover .weekly-goods-icon-2{
              display: block;
            }*/
    .weekly-goods-img {
      width: 180px;
      height: 180px;
      margin: 20px auto auto auto;
      position: relative;

      .frame-img {
        position: absolute;
        top: 0;
        left: 0;
      }

      img {
        width: 180px;
        height: 180px;
      }

      .move-img:hover {
        /* transform: translateY(-5px);
        transition-duration: 1s;*/
      }
    }

    .weekly-goods-intro {
      font-size: 18px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 600;
      color: #333333;
      padding: 8px 20px 0 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .weekly-goods-spec {
      font-size: 16px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333;
      padding-top: 8px;
      padding-left: 20px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .weekly-goods-noLogin {
      font-size: 20px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #fa0000;
      padding-top: 8px;
      padding-left: 20px;
    }

    .weekly-goods-loginPrice {
      padding-top: 8px;

      .weekly-price {
        font-size: 20px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 600;
        color: #fa0000;
        line-height: 20px;
        padding-left: 17px;
      }

      .weekly-old-price {
        font-size: 18px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #666;
        line-height: 17px;
      }
    }

    .goods-bottom-icon {
      display: flex;
      margin-left: 20px;
      margin-top: 8px;

      p {
        font-size: 12px;
        color: #FA0000;
        padding: 0 7px;
        background: #fff;
        border: 1px solid #FA0000;
        box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3), 0px 1px 2px 0px rgba(98, 152, 18, 0.1);
        border-radius: 2px;
        margin-right: 10px;
      }
    }
  }
}

.empty {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  // img {
  //   width: 618px;
  //   height: 454px;
  // }
  p {
    width: 100%;
    font-size: 14px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #666;
    text-align: center;
  }
}

.loadingPage {
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/public/Recommend.vue